/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/match_phrase.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Use `MATCH_PHRASE` to perform a `match_phrase` on the
 * specified field or expression.
 * Using `MATCH_PHRASE` is equivalent to using the `match_phrase` query in the Elasticsearch Query DSL.
 *
 * @example
 * FROM books
 * | WHERE MATCH_PHRASE(author, "William Faulkner")
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'match_phrase',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'query',
          type: 'keyword',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
        {
          name: 'options',
          type: 'function_named_parameters',
          optional: true,
          mapParams: '{name=\'analyzer\', values=[standard], description=\'Analyzer used to convert the text in the query value into token. Defaults to the index-time analyzer mapped for the field. If no analyzer is mapped, the index’s default analyzer is used.\', type=[keyword]}, {name=\'slop\', values=[1], description=\'Maximum number of positions allowed between matching tokens. Defaults to 0. Transposed terms have a slop of 2.\', type=[integer]}, {name=\'zero_terms_query\', values=[none, all], description=\'Indicates whether all documents or none are returned if the analyzer removes all tokens, such as when using a stop filter. Defaults to none.\', type=[keyword]}, {name=\'boost\', values=[2.5], description=\'Floating point number used to decrease or increase the relevance scores of the query. Defaults to 1.0.\', type=[float]}',
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
        {
          name: 'query',
          type: 'keyword',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
        {
          name: 'options',
          type: 'function_named_parameters',
          optional: true,
          mapParams: '{name=\'analyzer\', values=[standard], description=\'Analyzer used to convert the text in the query value into token. Defaults to the index-time analyzer mapped for the field. If no analyzer is mapped, the index’s default analyzer is used.\', type=[keyword]}, {name=\'slop\', values=[1], description=\'Maximum number of positions allowed between matching tokens. Defaults to 0. Transposed terms have a slop of 2.\', type=[integer]}, {name=\'zero_terms_query\', values=[none, all], description=\'Indicates whether all documents or none are returned if the analyzer removes all tokens, such as when using a stop filter. Defaults to none.\', type=[keyword]}, {name=\'boost\', values=[2.5], description=\'Floating point number used to decrease or increase the relevance scores of the query. Defaults to 1.0.\', type=[float]}',
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
